<div class="border-top nordic-blue-50-bg font-body-1">
  <button
    class="ps-xsmall-y ps-small-x align-center fill"
    [attr.id]="'product-expand-button' + id"
    [attr.aria-controls]="'product-expand-content' + id"
    [attr.aria-expanded]="open"
    (click)="open = !open"
  >
    {{ title }}
    <fcom-icon
      class="flex-1 flex--nogrow rotate"
      [class.rotate-active]="open"
      [name]="SvgLibraryIcon.CHEVRON_DOWN"
    ></fcom-icon>
  </button>

  <fcom-expand [open]="open" [ariaLabelledBy]="'product-expand-button' + id" [ariaId]="'product-expand-content' + id">
    <div class="ps-small-x ps-xsmall-y">
      <ng-content></ng-content>
    </div>
  </fcom-expand>
</div>
